import React, { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { Ifilter } from "../../../Interfaces/filter";
import { RazonService } from "../../../services/auxiliar/RazonService";

const UseComboRazon = (isOpen: boolean) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filter, setFilter] = useState<Ifilter>({
        skip: 0,
        take: 20,
        search: ""
    });
    const [dataComboRazon, setDataComboRazon] = useState<IComboBoxOption[]>([]);
    const comboBoxRefRazon = useRef<IComboBox>(null);
    const onClickComboRazon = () => comboBoxRefRazon.current?.focus(true);

    const onChange = (value:any) => {
        setFilter({ ...filter, search: value });
    }
    const _onkeyUpSearchRazon = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefRazon.current?.focus(false);
            setFilter({
                skip: 0,
                take: 20,
                search: ""
            });
        } else {
            // _openOption();
            let { value } = event?.target as HTMLInputElement;
            setFilter({ ...filter, search: value });
        }
    };

    const listarCombo = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        RazonService.ComboRazon(filter, newController).then((res) => {
            if (res.status === 200) {
                setDataComboRazon(res.data);
            }
        });
    };

    useEffect(() => {
        if (isOpen) {
            listarCombo();
        }
    }, [isOpen]);

    useEffect(() => {
        if (filter.search != "") {
            listarCombo()
        }
    }, [filter.search])

    return {
        dataComboRazon,
        onClickComboRazon,
        _onkeyUpSearchRazon,
        comboBoxRefRazon,
        onChange,
        filter,
        setFilter
    };
}

export { UseComboRazon }
